import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import './CustomerExperiencePage.css';
import './QuestionnairePage.css';
import { ReactComponent as BackArrow } from '../../../assets/left_arrow_black.svg';
import Button from '../../../components/button/Button';
import {
	mediaEndpoint,
	OptionsOnExperience,
	OptionsOnLanguage,
	OptionsOnPhysicalIntensity,
	ProgressSteps,
} from '../../../utils/utils';
import ProgressBar from '../components/ProgressBar';
import ReactPlayer from 'react-player';
import { storage } from '../../../services/Firebase';
import signup_question_one from '../../../assets/yoga_one.svg';
import signup_question_two from '../../../assets/pilates_one.svg';
import TextAnimation from './TextAnimation';
import { Mixpanel } from '../../../analytics/Mixpanel';
import { updateUserPreference } from '../../../store/features/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as MuteIcon } from '../../../assets/mute.svg';
import { ReactComponent as UnmuteIcon } from '../../../assets/unmute.svg';
import Loader from '../../../components/loader/Loader';
import video4 from '../../../assets/videos/ob-video-4.mp4';

const BezierCurve: React.FC = () => {
	const startPointX = 0; // Starting point X-coordinate
	const startPointY = 15; // Starting point Y-coordinate
	const controlPoint1X = 150; // Control point 1 X-coordinate
	const controlPoint1Y = 10; // Control point 1 Y-coordinate
	const controlPoint2X = 120; // Control point 2 X-coordinate
	const controlPoint2Y = 90; // Control point 2 Y-coordinate
	const endPointX = 280; // Ending point X-coordinate
	const endPointY = 90; // Ending point Y-coordinate

	const startPointX_2 = 0; // Starting point X-coordinate
	const startPointY_2 = 15; // Starting point Y-coordinate
	const controlPoint1X_2 = 50; // Control point 1 X-coordinate
	const controlPoint1Y_2 = 10; // Control point 1 Y-coordinate
	const controlPoint2X_2 = -20; // Control point 2 X-coordinate
	const controlPoint2Y_2 = 130; // Control point 2 Y-coordinate
	const endPointX_2 = 280; // Ending point X-coordinate
	const endPointY_2 = 150; // Ending point Y-coordinate

	return (
		<svg width='304' height='200'>
			<path
				className='drawn-line'
				d={`
          M ${startPointX_2} ${startPointY_2} 
          C ${controlPoint1X_2} ${controlPoint1Y_2}, 
            ${controlPoint2X_2} ${controlPoint2Y_2}, 
            ${endPointX_2} ${endPointY_2}
        `}
				fill='none'
				stroke='#B8ACF6'
				strokeWidth='4'
			/>
			<circle
				cx={endPointX_2 + 10}
				cy={endPointY_2}
				r={10}
				fill='none'
				stroke='#B8ACF6'
			/>
			<text
				x={endPointX_2 - 10}
				y={endPointY_2 + 20}
				fill='#B8ACF6'
				fontFamily={'Gordita-Medium'}
				fontSize={'12px'}
				fontWeight={'500'}
				textAnchor='middle'>
				Others
			</text>

			<path
				className='drawn-line'
				d={`
          M ${startPointX} ${startPointY} 
          C ${controlPoint1X} ${controlPoint1Y}, 
            ${controlPoint2X} ${controlPoint2Y}, 
            ${endPointX} ${endPointY}
        `}
				fill='none'
				stroke='blue'
				strokeWidth='4'
			/>
			<circle
				cx={endPointX + 10}
				cy={endPointY}
				r={10}
				fill='none'
				stroke='blue'
			/>
			<text
				x={endPointX - 4}
				y={endPointY + 20}
				fill='#4462EF'
				fontFamily={'Gordita-Medium'}
				fontSize={'12px'}
				fontWeight={'500'}
				textAnchor='middle'>
				Seek
			</text>
		</svg>
	);
};

interface IconWithTitleProps {
	icon: string; // You can use any type that represents your icon, e.g., React.ComponentType
	title: string;
	index: number;
	selectedIndex?: number;
	selectOptionHandler: (index: number) => void;
	page?: string;
}

const IconWithTitle: React.FC<IconWithTitleProps> = ({
	page,
	icon,
	title,
	index,
	selectedIndex,
	selectOptionHandler,
}) => {
	const isSelected = selectedIndex === index;
	return (
		<div
			onClick={selectOptionHandler.bind(null, index)}
			className={`customer-experience-icon-with-title ${
				isSelected ? 'selected-customer-experience-icon-with-title' : ''
			}`}>
			<span
				className={`customer-experience-title  ${
					isSelected ? 'selected-customer-experience-title' : ''
				}`}
				style={{
					textAlign: page == 'LANGUAGE' ? 'center' : 'start',
					width: '100%',
				}}>
				{title}
			</span>
			{icon === 'Never' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'>
					<path
						fill-rule='evenodd'
						clip-rule='evenodd'
						d='M18.6087 4.33687C18.2611 4.34819 17.9316 4.49415 17.6898 4.74401L4.43166 18.0047C4.29889 18.127 4.19223 18.2753 4.11809 18.4399C4.04396 18.6046 4.00388 18.7823 4.00027 18.9628C3.99666 19.1434 4.02958 19.3228 4.09707 19.4903C4.16456 19.6578 4.26522 19.8101 4.39299 19.9377C4.52077 20.0653 4.67302 20.1654 4.8406 20.2327C5.00818 20.2999 5.18763 20.3327 5.36816 20.3288C5.54869 20.3249 5.72658 20.2848 5.89113 20.2104C6.05567 20.136 6.20349 20.0291 6.32568 19.8962L19.5891 6.63811C19.7847 6.45 19.9185 6.20673 19.9728 5.9409C20.0272 5.67507 19.9995 5.39927 19.8935 5.14951C19.7875 4.89975 19.6082 4.68782 19.3792 4.54223C19.1503 4.39665 18.8825 4.32429 18.6113 4.33425L18.6087 4.33687Z'
						fill='#FAA53D'
					/>
					<path
						fill-rule='evenodd'
						clip-rule='evenodd'
						d='M5.3693 4.33697C5.10159 4.33535 4.83953 4.41386 4.61695 4.56261C4.39436 4.71136 4.22146 4.92356 4.12054 5.17152C4.01962 5.41949 3.99533 5.69185 4.05078 5.95376C4.10624 6.21566 4.23891 6.45504 4.43167 6.64083L17.6925 19.8963C17.9447 20.1406 18.2829 20.2762 18.6341 20.2736C18.9854 20.2711 19.3215 20.1305 19.5702 19.8825C19.8189 19.6345 19.9603 19.2988 19.9638 18.9476C19.9674 18.5964 19.8328 18.2577 19.5892 18.0048L6.32568 4.74411C6.20145 4.61593 6.05284 4.51383 5.8886 4.4439C5.72436 4.37398 5.5478 4.33769 5.3693 4.33697Z'
						fill='#FAA53D'
					/>
				</svg>
			)}
			{icon === 'Few' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'>
					<g clip-path='url(#clip0_335_4104)'>
						<path
							d='M3.30518 9.67023C3.71272 8.14346 4.51685 6.75166 5.636 5.63603M5.63494 18.365C4.51649 17.2487 3.71322 15.8564 3.30662 14.3294M14.3297 20.6948C12.8037 21.1052 11.1963 21.1047 9.67059 20.6933M20.6947 14.3297C20.2872 15.8565 19.4831 17.2483 18.3639 18.3639M18.365 5.63496C19.4834 6.75129 20.2867 8.14359 20.6933 9.67061M9.6702 3.30521C11.1962 2.89476 12.8036 2.89526 14.3293 3.30665'
							stroke='#FAA53D'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
					</g>
					<defs>
						<clipPath id='clip0_335_4104'>
							<rect width='24' height='24' fill='white' />
						</clipPath>
					</defs>
				</svg>
			)}
			{icon === 'Lot' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'>
					<path
						d='M14.2634 16.6943C13.9912 16.7335 13.8023 16.9861 13.8416 17.2584C14.0486 18.693 13.3489 20.159 12 20.8069C10.6512 20.159 9.95139 18.6931 10.1584 17.2584C10.1977 16.9861 10.0089 16.7335 9.73666 16.6943C9.46474 16.6549 9.2118 16.8438 9.17257 17.116C8.88438 19.1141 9.97319 21.0669 11.8128 21.8128C11.9328 21.8614 12.0671 21.8615 12.1871 21.8128C14.0127 21.0726 15.1179 19.1302 14.8274 17.116C14.7882 16.8438 14.5353 16.655 14.2634 16.6943Z'
						fill='#FAA53D'
					/>
					<path
						d='M23.9179 14.154C23.3386 12.6961 22.2282 11.475 20.8327 10.7432C21.3899 9.20049 21.3945 7.46387 20.7242 5.87856C20.6737 5.75926 20.5787 5.66424 20.4594 5.61381C18.8057 4.91443 16.8916 4.93093 15.208 5.65885C14.9555 5.76803 14.8393 6.06118 14.9485 6.31365C15.0577 6.56612 15.3509 6.68232 15.6033 6.57315C16.9746 5.98018 18.5225 5.93987 19.8826 6.45559C20.6806 8.55095 20.1514 10.9371 18.5077 12.5807C16.8135 14.275 14.3351 14.7847 12.1939 13.8792C12.1853 13.8756 12.1486 13.8626 12.1435 13.8611C12.1399 13.86 12.1016 13.8504 12.0957 13.8492C12.0947 13.849 12.0582 13.8435 12.0547 13.843C12.042 13.8416 12.0114 13.8401 12.0061 13.84C11.9928 13.8399 11.9623 13.8414 11.9573 13.8418C11.9442 13.8429 11.9102 13.848 11.9031 13.8493C11.9005 13.8498 11.8618 13.8594 11.8554 13.8613C11.8498 13.863 11.8116 13.8768 11.806 13.8791C9.66465 14.7847 7.18632 14.2749 5.49216 12.5807C3.84919 10.9377 3.31894 8.55174 4.11727 6.45554C5.47744 5.93978 7.0253 5.98018 8.39659 6.5731C8.64882 6.68228 8.94221 6.56617 9.05138 6.3136C9.16055 6.06114 9.04435 5.76798 8.79188 5.65881C7.10818 4.93084 5.19418 4.91443 3.54048 5.61376C3.42113 5.6642 3.32616 5.75917 3.27568 5.87851C2.60682 7.46049 2.60865 9.19698 3.16712 10.7431C1.77146 11.4751 0.661179 12.6962 0.0819443 14.1541C0.0350225 14.2722 0.0350225 14.4038 0.0819443 14.5219C0.585757 15.7898 1.46223 16.8579 2.61643 17.6109C2.84673 17.7612 3.1554 17.6963 3.30568 17.4659C3.45596 17.2355 3.39104 16.9269 3.16069 16.7767C2.23608 16.1735 1.52162 15.3333 1.0846 14.3381C1.58569 13.201 2.47248 12.2485 3.57399 11.6552C5.03298 14.3712 8.09579 15.7867 11.0085 15.1687C9.66259 17.2165 7.15323 18.1192 4.83062 17.5137C4.56451 17.4442 4.2924 17.6038 4.22302 17.87C4.1536 18.1362 4.31316 18.4082 4.57937 18.4776C7.43312 19.2216 10.4769 18.0128 11.9999 15.4589C13.1563 17.3977 15.2933 18.6933 17.7274 18.6933C20.5025 18.6933 22.9317 17.0023 23.9177 14.5219C23.9648 14.4038 23.9648 14.2721 23.9179 14.154ZM17.7275 17.6972C15.7777 17.6972 14.0198 16.7331 12.9916 15.1688C15.9833 15.8034 19.0063 14.2977 20.4258 11.6552C21.5274 12.2484 22.414 13.2008 22.9153 14.3381C22.0173 16.3854 20.0026 17.6972 17.7275 17.6972Z'
						fill='#FAA53D'
					/>
					<path
						d='M12.1871 2.18729C12.067 2.13854 11.9328 2.13854 11.8128 2.18729C9.38837 3.17035 7.64453 5.60921 7.64453 8.49338C7.64453 11.3776 9.38828 13.8163 11.8128 14.7995C11.9327 14.8482 12.067 14.8482 12.1871 14.7996C13.8925 14.1081 15.2504 12.7016 15.9126 10.9408C16.0094 10.6833 15.8792 10.3961 15.6218 10.2993C15.364 10.2026 15.0771 10.3328 14.9802 10.5901C14.4402 12.0262 13.3604 13.1846 11.9998 13.7965C9.95233 12.8787 8.64058 10.8196 8.64058 8.49338C8.64058 6.16702 9.95228 4.10785 11.9999 3.19018C14.0476 4.1078 15.3593 6.16698 15.3593 8.49338C15.3593 8.60101 15.3567 8.69907 15.3516 8.79324C15.3364 9.06784 15.5468 9.30277 15.8215 9.31787C16.0967 9.33418 16.331 9.12263 16.3461 8.84799C16.5047 5.98135 14.8422 3.26387 12.1871 2.18729Z'
						fill='#FAA53D'
					/>
				</svg>
			)}
			{icon === 'Low' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'>
					<path
						d='M11.2 24.2236V18.443C11.2 17.686 10.48 17.0667 9.6 17.0667C8.72 17.0667 8 17.686 8 18.443V24.2236C8 24.9806 8.72 25.6 9.6 25.6C10.48 25.6 11.2 24.9806 11.2 24.2236Z'
						fill='#FAA53D'
					/>
					<path
						d='M20.3077 24.2605C20.3077 24.9972 20.8985 25.6 21.6205 25.6C22.3426 25.6 22.9333 24.9972 22.9333 24.2605V7.73953C22.9333 7.00278 22.3426 6.39999 21.6205 6.39999C20.8985 6.39999 20.3077 7.00278 20.3077 7.73953V24.2605Z'
						fill='#FFD39E'
					/>
					<path
						d='M17.0256 13.187V24.2605C17.0256 24.9972 16.4349 25.6 15.7128 25.6C14.9908 25.6 14.4 24.9972 14.4 24.2605V13.187C14.4 12.4502 14.9908 11.8474 15.7128 11.8474C16.4349 11.8474 17.0256 12.4502 17.0256 13.187Z'
						fill='#FFD39E'
					/>
				</svg>
			)}
			{icon === 'Medium' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'>
					<path
						d='M11.2 24.2236V18.443C11.2 17.686 10.48 17.0667 9.6 17.0667C8.72 17.0667 8 17.686 8 18.443V24.2236C8 24.9806 8.72 25.6 9.6 25.6C10.48 25.6 11.2 24.9806 11.2 24.2236Z'
						fill='#FAA53D'
					/>
					<path
						d='M20.3077 24.2605C20.3077 24.9972 20.8984 25.6 21.6205 25.6C22.3425 25.6 22.9333 24.9972 22.9333 24.2605V7.73953C22.9333 7.00278 22.3425 6.39999 21.6205 6.39999C20.8984 6.39999 20.3077 7.00278 20.3077 7.73953V24.2605Z'
						fill='#FFD39E'
					/>
					<path
						d='M17.0256 13.187V24.2605C17.0256 24.9972 16.4349 25.6 15.7128 25.6C14.9908 25.6 14.4 24.9972 14.4 24.2605V13.187C14.4 12.4502 14.9908 11.8474 15.7128 11.8474C16.4349 11.8474 17.0256 12.4502 17.0256 13.187Z'
						fill='#FAA53D'
					/>
				</svg>
			)}
			{icon === 'High' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'>
					<path
						d='M11.2 24.2236V18.443C11.2 17.686 10.48 17.0667 9.6 17.0667C8.72 17.0667 8 17.686 8 18.443V24.2236C8 24.9806 8.72 25.6 9.6 25.6C10.48 25.6 11.2 24.9806 11.2 24.2236Z'
						fill='#FAA53D'
					/>
					<path
						d='M20.3077 24.2605C20.3077 24.9972 20.8985 25.6 21.6205 25.6C22.3426 25.6 22.9333 24.9972 22.9333 24.2605V7.73953C22.9333 7.00278 22.3426 6.39999 21.6205 6.39999C20.8985 6.39999 20.3077 7.00278 20.3077 7.73953V24.2605Z'
						fill='#FAA53D'
					/>
					<path
						d='M17.0256 13.187V24.2605C17.0256 24.9972 16.4349 25.6 15.7128 25.6C14.9908 25.6 14.4 24.9972 14.4 24.2605V13.187C14.4 12.4502 14.9908 11.8474 15.7128 11.8474C16.4349 11.8474 17.0256 12.4502 17.0256 13.187Z'
						fill='#FAA53D'
					/>
				</svg>
			)}
		</div>
	);
};

const IconWithTitlePhysical: React.FC<IconWithTitleProps> = ({
	page,
	icon,
	title,
	index,
	selectedIndex,
	selectOptionHandler,
}) => {
	const isSelected = selectedIndex === index;
	return (
		<div
			onClick={selectOptionHandler.bind(null, index)}
			className={`customer-experience-icon-with-title ${
				isSelected ? 'selected-customer-experience-icon-with-title' : ''
			}`}>
			<span
				className={`customer-experience-title  ${
					isSelected ? 'selected-customer-experience-title' : ''
				}`}
				style={{ alignSelf: 'center', alignItems: 'center' }}>
				{title}
			</span>

			{icon === 'Low' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'>
					<path
						d='M11.2 24.2236V18.443C11.2 17.686 10.48 17.0667 9.6 17.0667C8.72 17.0667 8 17.686 8 18.443V24.2236C8 24.9806 8.72 25.6 9.6 25.6C10.48 25.6 11.2 24.9806 11.2 24.2236Z'
						fill='#FAA53D'
					/>
					<path
						d='M20.3077 24.2605C20.3077 24.9972 20.8985 25.6 21.6205 25.6C22.3426 25.6 22.9333 24.9972 22.9333 24.2605V7.73953C22.9333 7.00278 22.3426 6.39999 21.6205 6.39999C20.8985 6.39999 20.3077 7.00278 20.3077 7.73953V24.2605Z'
						fill='#FFD39E'
					/>
					<path
						d='M17.0256 13.187V24.2605C17.0256 24.9972 16.4349 25.6 15.7128 25.6C14.9908 25.6 14.4 24.9972 14.4 24.2605V13.187C14.4 12.4502 14.9908 11.8474 15.7128 11.8474C16.4349 11.8474 17.0256 12.4502 17.0256 13.187Z'
						fill='#FFD39E'
					/>
				</svg>
			)}
			{icon === 'Medium' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'>
					<path
						d='M11.2 24.2236V18.443C11.2 17.686 10.48 17.0667 9.6 17.0667C8.72 17.0667 8 17.686 8 18.443V24.2236C8 24.9806 8.72 25.6 9.6 25.6C10.48 25.6 11.2 24.9806 11.2 24.2236Z'
						fill='#FAA53D'
					/>
					<path
						d='M20.3077 24.2605C20.3077 24.9972 20.8984 25.6 21.6205 25.6C22.3425 25.6 22.9333 24.9972 22.9333 24.2605V7.73953C22.9333 7.00278 22.3425 6.39999 21.6205 6.39999C20.8984 6.39999 20.3077 7.00278 20.3077 7.73953V24.2605Z'
						fill='#FFD39E'
					/>
					<path
						d='M17.0256 13.187V24.2605C17.0256 24.9972 16.4349 25.6 15.7128 25.6C14.9908 25.6 14.4 24.9972 14.4 24.2605V13.187C14.4 12.4502 14.9908 11.8474 15.7128 11.8474C16.4349 11.8474 17.0256 12.4502 17.0256 13.187Z'
						fill='#FAA53D'
					/>
				</svg>
			)}
			{icon === 'High' && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'>
					<path
						d='M11.2 24.2236V18.443C11.2 17.686 10.48 17.0667 9.6 17.0667C8.72 17.0667 8 17.686 8 18.443V24.2236C8 24.9806 8.72 25.6 9.6 25.6C10.48 25.6 11.2 24.9806 11.2 24.2236Z'
						fill='#FAA53D'
					/>
					<path
						d='M20.3077 24.2605C20.3077 24.9972 20.8985 25.6 21.6205 25.6C22.3426 25.6 22.9333 24.9972 22.9333 24.2605V7.73953C22.9333 7.00278 22.3426 6.39999 21.6205 6.39999C20.8985 6.39999 20.3077 7.00278 20.3077 7.73953V24.2605Z'
						fill='#FAA53D'
					/>
					<path
						d='M17.0256 13.187V24.2605C17.0256 24.9972 16.4349 25.6 15.7128 25.6C14.9908 25.6 14.4 24.9972 14.4 24.2605V13.187C14.4 12.4502 14.9908 11.8474 15.7128 11.8474C16.4349 11.8474 17.0256 12.4502 17.0256 13.187Z'
						fill='#FAA53D'
					/>
				</svg>
			)}
		</div>
	);
};

export enum ONBOARDING_STATES {
	LANDING_PAGE,
	WELCOME_PAGE,
	PRIORITIES_PAGE,
	EXPERIENCE_DETAILS_PAGE,
	QUESTIONARE_PAGE,
	TESTIMONIAL_PAGE,
	VIDEO_ANIMATION,
	CUSTOMER_TESTIMONIAL_PAGE,
	CUSTOMER_LOCATION_PAGE,
	CUSTOMER_EXPERIENCE_PAGE,
	CUSTOMER_AGE_GROUP_PAGE,
	THANK_YOU,
	THANK_YOU_2,
	TRIAL_START_DATE,
	TRIAL_DATE_SET,
	READY_TO_SET_YOUR_GOALS,
	SET_YOUR_GOALS,
	SET_YOUR_REMINDERS,
	CONGRATULATIONS,
}

export enum STATES {
	MEDITATION_EXPERIENCE,
	LANGUAGE,
	VIDEO_TESTIMONIAL_LANGUAGE,
	STATEMENTS,
	PHYSICAL_ACTIVITY,
	VIDEO_TESTIMONIAL_PHYSICAL,
	TEXT_TESTIMONIAL_365_DAYS,
	ATTENDANCE_ANIMATION,
	VIDEO_TESTIMONIAL_TIME,
	TEXT_TESTIMONIAL_7_SLOTS,
	GREETINGS,
	BENEFITS,
}

interface CustomerExperiencePageProps {
	onCustomerExperiencePageContinueHandler: (questionState: any) => void;
	onBackArrowClick: () => void;
	progress: any;
	name: string;
	increaseProgressBy5_5: any;
	decreaseProgressBy5_5: any;
	currentState: any;
	isOnboardingA: boolean;
	setOnboardingState: any;
	backScreen: string;
}

interface Question {
	question: string;
	option: boolean | null;
}

const CustomerExperiencePage: React.FC<CustomerExperiencePageProps> = ({
	currentState,
	increaseProgressBy5_5,
	decreaseProgressBy5_5,
	name,
	progress,
	onCustomerExperiencePageContinueHandler,
	onBackArrowClick,
	isOnboardingA,
	setOnboardingState,
	backScreen,
}) => {
	const [state, setState] = useState<STATES>(currentState);
	const dispatch = useDispatch();
	const userPreferences = useSelector(
		(state: any) => state.auth.userPreferences
	);

	const onboardingExperimentKey = useSelector(
		(state: any) => state.abExperiment.data.onboarding_experiment_key
	);

	const handleUpdatePreference = (key: string, value: any) => {
		dispatch(updateUserPreference({ key, value }));
	};

	const [isVideoEndedOne, setIsVideoEndedOne] = useState(false);
	const [isVideoEndedTwo, setIsVideoEndedTwo] = useState(false);
	const [isVideoEndedThree, setIsVideoEndedThree] = useState(false);

	const [isVideoPlayingOne, setIsVideoPlayingOne] = useState(false);
	const [isVideoPlayingTwo, setIsVideoPlayingTwo] = useState(false);
	const [isVideoPlayingThree, setIsVideoPlayingThree] = useState(false);

	const [muted, setMuted] = useState(true);

	const [is7SlotsAnimationEnded, setIs7SlotsAnimationEnded] = useState(false);

	const [isAttendanceAnimationDone, setIsAttendanceAnimationDone] =
		useState(false);

	const [videoUrlOne, setVideoUrlOne] = useState('');
	const [videoUrlTwo, setVideoUrlTwo] = useState('');
	const [videoUrlThree, setVideoUrlThree] = useState('');
	const [animation365Complete, setAnimation365Complete] = useState(false);

	// const [customerExperience, setCustomerExperience] = useState<CustomerExperienceType>();

	const [questionState, setQuestionState] = useState<Question[]>([]);

	const [selectedIndexOne, setSelectedIndexOne] = useState<number>(
		userPreferences?.userExperience
	);
	const [selectedIndexTwo, setSelectedIndexTwo] = useState<number>(
		userPreferences?.language
	);
	const [selectedIndexThree, setSelectedIndexThree] = useState<number>(
		userPreferences?.physical_activity
	);

	const [index, setIndex] = useState(0);

	const [yesSelectedIndex0, setYesSelectedIndex0] = useState(
		userPreferences?.onboarding_questionnaire?.[2]?.option === true
	);
	const [noSelectedIndex0, setNoSelectedIndex0] = useState(
		userPreferences?.onboarding_questionnaire?.[2]?.option === false
	);
	const [yesSelectedIndex1, setYesSelectedIndex1] = useState(
		userPreferences?.onboarding_questionnaire?.[3]?.option === true
	);
	const [noSelectedIndex1, setNoSelectedIndex1] = useState(
		userPreferences?.onboarding_questionnaire?.[3]?.option === false
	);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [state, index]);

	useEffect(() => {
		setState(currentState);
	}, [currentState]);

	const onAnimation365Complete = () => {
		setAnimation365Complete(true);
	};

	const onAnimation7SlotsComplete = () => {
		setIs7SlotsAnimationEnded(true);
	};

	useEffect(() => {
		if (state === STATES.ATTENDANCE_ANIMATION) {
			setTimeout(
				() => setIsAttendanceAnimationDone(true),
				isOnboardingA ? 0 : 3000
			);
		}
		if (state === STATES.TEXT_TESTIMONIAL_7_SLOTS) {
			setStartAnimationTwo(false);
		}
		if (
			state === STATES.VIDEO_TESTIMONIAL_LANGUAGE ||
			state === STATES.VIDEO_TESTIMONIAL_PHYSICAL ||
			state === STATES.VIDEO_TESTIMONIAL_TIME
		) {
			setMuted(true);
		}
	}, [state]);

	useEffect(() => {
		const urlOne = mediaEndpoint + 'video/Pre Sign-up Videos/ob-video-3.mp4';
		setVideoUrlOne(urlOne);

		const urlTwo = mediaEndpoint + 'video/Pre Sign-up Videos/ob-video-2.mp4';
		setVideoUrlTwo(urlTwo);

		const urlThree = mediaEndpoint + 'video/Pre Sign-up Videos/ob-video-4.mp4';
		setVideoUrlThree(urlThree);
	}, []);

	useEffect(() => {
		isOnboardingA
			? Mixpanel.track('onboarding_questionnaire_info', {
					event_action: 'viewed',
					page_heading: '2.  Personalise your Experience',
					event_page:
						'Which language will you prefer to get instructions from us?',
					onboarding_experiment_key: onboardingExperimentKey,
			  })
			: Mixpanel.track('onboarding_questionnaire_info', {
					event_action: 'viewed',
					page_heading: '2. Personalise your Experience',
					event_page: "What's your experience in meditation?",
					onboarding_experiment_key: onboardingExperimentKey,
			  });
	}, []);

	const selectOptionHandlerExperience = (selectedIndex: number) => {
		increaseProgressBy5_5();
		setSelectedIndexOne(selectedIndex);
		handleUpdatePreference('userExperience', selectedIndex);
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: '2.  Personalise your Experience',
			event_page: "What's your experience in meditation?",
			response: OptionsOnExperience[selectedIndex].title,
			onboarding_experiment_key: onboardingExperimentKey,
		});

		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: '2.  Personalise your Experience',
			event_page: 'Which language will you prefer to get instructions from us?',
			onboarding_experiment_key: onboardingExperimentKey,
		});

		setTimeout(() => setState(STATES.LANGUAGE), 1000);
	};

	const selectOptionHandlerLanguage = (selectedIndex: number) => {
		increaseProgressBy5_5();
		setSelectedIndexTwo(selectedIndex);
		handleUpdatePreference('language', selectedIndex);
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: '2. Personalise your Experience',
			event_page: 'Which language will you prefer to get instructions from us?',
			response: OptionsOnLanguage[selectedIndex].title,
			onboarding_experiment_key: onboardingExperimentKey,
		});

		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Language video',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});

		setTimeout(() => setState(STATES.VIDEO_TESTIMONIAL_LANGUAGE), 1000);
	};

	const selectOptionHandlerPhysicalActivity = (selectedIndex: number) => {
		setSelectedIndexThree(selectedIndex);
		handleUpdatePreference('physical_activity', selectedIndex);
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: '2. Personalise your Experience',
			question: 'How intense is the physical activity?',
			event_page: 'onboarding_questionnaire_info',
			response: OptionsOnPhysicalIntensity[selectedIndex].title,
			onboarding_experiment_key: onboardingExperimentKey,
		});

		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Physical intensity video',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		setTimeout(() => setState(STATES.VIDEO_TESTIMONIAL_PHYSICAL), 1000);
	};

	const selectOptionHandlerVideoLanguage = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Language video',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});

		isOnboardingA
			? Mixpanel.track('onboarding_questionnaire_info', {
					event_action: 'viewed',
					page_heading: 'Seek users are the most regular',
					onboarding_experiment_key: onboardingExperimentKey,
			  })
			: Mixpanel.track('onboarding_questionnaire_info', {
					event_action: 'viewed',
					page_heading: '2. Personalise your Experience',
					event_page: 'Do you agree with the following statement?',
					question:
						'Some physical activity everyday is important to manage stress and fight diseases.',
					onboarding_experiment_key: onboardingExperimentKey,
			  });
		isOnboardingA
			? setState(STATES.ATTENDANCE_ANIMATION)
			: setState(STATES.STATEMENTS);
	};

	const selectOptionHandlerVideoPhysical = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Physical intensity video',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});

		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'We practice with you 365 days a year',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		setState(STATES.TEXT_TESTIMONIAL_365_DAYS);
	};

	const selectOptionHandlerVideoTime = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Time video',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});

		!isOnboardingA &&
			Mixpanel.track('onboarding_questionnaire_info', {
				event_action: 'viewed',
				page_heading: 'Attend as many as you want.',
				event_page: 'onboarding_questionnaire_info',
				onboarding_experiment_key: onboardingExperimentKey,
			});
		isOnboardingA
			? onCustomerExperiencePageContinueHandler(questionState)
			: setState(STATES.TEXT_TESTIMONIAL_7_SLOTS);
	};

	const selectOptionHandler7slotsTestimonial = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Attend as many as you want.',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		onCustomerExperiencePageContinueHandler(questionState);
	};

	const onGreetingsContinueHandler = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Let us understand what all is included in your trial',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		onCustomerExperiencePageContinueHandler(questionState);
	};

	const selectOptionHandler365Testimonial = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'We practice with you 365 days a year',
			onboarding_experiment_key: onboardingExperimentKey,
		});

		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Seek users are the most regular',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		setState(STATES.ATTENDANCE_ANIMATION);
	};

	const onAttendanceAnimationComplete = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Seek users are the most regular',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Time video',
			onboarding_experiment_key: onboardingExperimentKey,
		});
		setState(STATES.VIDEO_TESTIMONIAL_TIME);
	};

	const onQuestionSelectHandler = (option: boolean) => {
		if (index === 0) {
			if (option) {
				setYesSelectedIndex0(true);
				setNoSelectedIndex0(false);
			} else {
				setYesSelectedIndex0(false);
				setNoSelectedIndex0(true);
			}
		} else if (index === 1) {
			if (option) {
				setYesSelectedIndex1(true);
				setNoSelectedIndex1(false);
			} else {
				setYesSelectedIndex1(false);
				setNoSelectedIndex1(true);
			}
		}

		const updatedQuestions = [...questionState];
		if (index === 0) {
			updatedQuestions[index] = {
				question:
					'Some physical activity everyday is important to manage stress and fight diseases.',
				option: option,
			};

			Mixpanel.track('onboarding_questionnaire_info', {
				event_action: 'clicked',
				page_heading: '2. Personalise your Experience',
				event_page: 'Do you agree with the following statement?',
				question:
					'Some physical activity everyday is important to manage stress and fight diseases.',
				answer: option,
				onboarding_experiment_key: onboardingExperimentKey,
			});

			Mixpanel.track('onboarding_questionnaire_info', {
				event_action: 'viewed',
				page_heading: '2. Personalise your Experience',
				event_page: 'How intense is the physical activity?',
				onboarding_experiment_key: onboardingExperimentKey,
			});

			setQuestionState(updatedQuestions);

			setTimeout(() => {
				setQuestionState(updatedQuestions);
				increaseProgressBy5_5();
				setState(STATES.PHYSICAL_ACTIVITY);
			}, 1000);
		}
	};

	const onBackArrowClickCustomerExperience = () => {
		try {
			setState((prevState) => {
				switch (prevState) {
					case STATES.MEDITATION_EXPERIENCE:
						onBackArrowClick();
						return STATES.MEDITATION_EXPERIENCE;

					case STATES.LANGUAGE: {
						decreaseProgressBy5_5();
						setOnboardingState(ONBOARDING_STATES.CUSTOMER_TESTIMONIAL_PAGE);
						return isOnboardingA
							? STATES.LANGUAGE
							: STATES.MEDITATION_EXPERIENCE;
					}
					case STATES.VIDEO_TESTIMONIAL_LANGUAGE: {
						decreaseProgressBy5_5();
						return STATES.LANGUAGE;
					}
					case STATES.STATEMENTS: {
						// decreaseProgressBy5_5();
						if (index === 1) {
							setIndex(0);
							return STATES.STATEMENTS;
						}
						return STATES.VIDEO_TESTIMONIAL_LANGUAGE;
					}

					case STATES.PHYSICAL_ACTIVITY: {
						decreaseProgressBy5_5();
						return STATES.STATEMENTS;
					}
					case STATES.VIDEO_TESTIMONIAL_PHYSICAL: {
						return STATES.PHYSICAL_ACTIVITY;
					}

					case STATES.TEXT_TESTIMONIAL_365_DAYS: {
						return STATES.VIDEO_TESTIMONIAL_PHYSICAL;
					}
					case STATES.ATTENDANCE_ANIMATION: {
						return isOnboardingA
							? STATES.VIDEO_TESTIMONIAL_LANGUAGE
							: STATES.TEXT_TESTIMONIAL_365_DAYS;
					}

					case STATES.VIDEO_TESTIMONIAL_TIME: {
						return STATES.ATTENDANCE_ANIMATION;
					}

					case STATES.TEXT_TESTIMONIAL_7_SLOTS: {
						return STATES.VIDEO_TESTIMONIAL_TIME;
					}

					default:
						return prevState;
				}
			});
		} catch (e) {}
	};
	const [startAnimationTwo, setStartAnimationTwo] = useState(false);

	const on7SlotsFirstAnimationComplete = (index: number) => {
		if (index === 1) {
			setStartAnimationTwo(true);
		} else if (index === 2) {
			onAnimation7SlotsComplete();
		}
	};

	const handleMuteClick = () => {
		if (muted) {
			Mixpanel.track('click_mute', {
				event_action: 'clicked',
				event_page: 'pre_sign_up_videos',
				onboarding_experiment_key: onboardingExperimentKey,
			});
		}
		setMuted(!muted);
	};

	return (
		<Container
			className={`${
				state === STATES.VIDEO_TESTIMONIAL_LANGUAGE ||
				state === STATES.VIDEO_TESTIMONIAL_PHYSICAL ||
				state === STATES.VIDEO_TESTIMONIAL_TIME
					? 'customer-experience-page-container-white-bg'
					: 'customer-experience-page-container'
			}`}>
			{(state === STATES.VIDEO_TESTIMONIAL_LANGUAGE ||
				state === STATES.VIDEO_TESTIMONIAL_PHYSICAL ||
				state === STATES.VIDEO_TESTIMONIAL_TIME) && (
				<div className='customer-experience-volume'>
					{muted ? (
						<MuteIcon onClick={handleMuteClick} />
					) : (
						<UnmuteIcon onClick={handleMuteClick} />
					)}
				</div>
			)}
			<div
				className={`${
					state === STATES.VIDEO_TESTIMONIAL_LANGUAGE ||
					state === STATES.VIDEO_TESTIMONIAL_PHYSICAL ||
					state === STATES.VIDEO_TESTIMONIAL_TIME
						? 'customer-experience-header-container-white-bg'
						: 'customer-experience-header-container'
				}`}>
				<BackArrow
					onClick={onBackArrowClickCustomerExperience}
					width={48}
					height={48}
				/>

				{/* {(state === STATES.MEDITATION_EXPERIENCE ||
					state === STATES.LANGUAGE ||
					state === STATES.STATEMENTS ||
					state === STATES.PHYSICAL_ACTIVITY) && (
					<div className={'customer-experience-header-title'}>
						2. Personalise your Experience
					</div>
				)} */}
				<div />
			</div>

			<div className={'customer-experience-body-container'}>
				{(state === STATES.MEDITATION_EXPERIENCE ||
					state === STATES.LANGUAGE ||
					state === STATES.STATEMENTS ||
					state === STATES.PHYSICAL_ACTIVITY) && (
					<ProgressBar
						threshold={ProgressSteps.SECTION_TWO}
						progress={progress}></ProgressBar>
				)}

				{state === STATES.MEDITATION_EXPERIENCE && (
					<>
						<p className={'customer-experience-body-title'}>
							What's your experience in meditation?
						</p>
						<div
							className={'customer-experience-body-container'}
							style={{ marginTop: '102px', width: '100%' }}>
							{OptionsOnExperience?.map((option: any, index: number) => (
								<IconWithTitle
									selectOptionHandler={selectOptionHandlerExperience}
									selectedIndex={selectedIndexOne}
									index={index}
									title={option.title}
									icon={option.icon}
									key={index}
								/>
							))}
						</div>
					</>
				)}

				{state === STATES.LANGUAGE && (
					<>
						<p className={'customer-experience-body-title'}>
							Which language will you prefer to get instructions from us?
						</p>
						<div
							className={'customer-experience-body-container'}
							style={{ marginTop: '84px', width: '100%' }}>
							{OptionsOnLanguage?.map((option: any, index: number) => (
								<IconWithTitle
									page={'LANGUAGE'}
									selectOptionHandler={selectOptionHandlerLanguage}
									selectedIndex={selectedIndexTwo}
									index={index}
									title={option.title}
									icon={option.icon}
									key={index}
								/>
							))}
						</div>
					</>
				)}

				{state === STATES.VIDEO_TESTIMONIAL_LANGUAGE && (
					<>
						{!isVideoPlayingOne && (
							<div
								style={{
									position: 'absolute',
									zIndex: 0,
									top: '50%',
									left: '50%',
									transform: 'translate(-50%, -50%)',
								}}>
								<Loader grey />
							</div>
						)}
						{
							<ReactPlayer
								controls={false}
								playing={true}
								autoPlay={true}
								muted={muted}
								loop={true}
								playsinline={true}
								fileconfig={{ attributes: { autoPlay: true } }}
								url={videoUrlOne}
								width={'100%'}
								height={472}
								onPlay={() => {
									setIsVideoPlayingOne(true);
									setTimeout(
										() => {
											setIsVideoEndedOne(true);
										},
										isOnboardingA ? 0 : 5000
									);
								}}
								style={{
									display: 'flex',
									width: '100%',
									maxWidth: '327px',
									maxHeight: '472px',
									height: 'auto',
									alignSelf: 'center',
									opacity: isVideoPlayingOne ? '1' : '0.01',
									margin: '0 auto',
								}}
							/>
						}
						<Button
							disabled={!isVideoEndedOne}
							isSticky={true}
							style={{
								alignSelf: 'center',
								marginBottom: '24px',
								background: !isVideoEndedOne
									? 'var(--Inactive-Color, #D6D6D6)'
									: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
							}}
							onClick={selectOptionHandlerVideoLanguage}
							label={'Okay'}></Button>
					</>
				)}

				{state === STATES.STATEMENTS && (
					<>
						<p className={'customer-experience-body-title'}>
							Do you agree with the following statement?.
						</p>
						{index === 0 && (
							<>
								<img
									src={signup_question_one}
									alt=''
									style={{ width: '160px', height: '160px' }}
								/>
								<p className={'question-on-signup'}>
									“Some physical activity everyday is important to manage stress
									and fight diseases.”
								</p>
								<div
									style={{
										display: 'flex',
										width: '327px',
										flexDirection: 'row',
										alignItems: 'center',
										marginTop: '24px',
										justifyContent: 'space-around',
									}}>
									<div
										className={`question-button ${
											yesSelectedIndex0 ? 'question-button-selected' : ''
										}`}
										onClick={onQuestionSelectHandler.bind(null, true)}>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='25'
											height='24'
											viewBox='0 0 25 24'
											fill='none'>
											<path
												fill-rule='evenodd'
												clip-rule='evenodd'
												d='M19.6275 6.66289C19.2901 6.67036 18.9651 6.79138 18.705 7.00639L9.54446 14.3625L6.44996 10.2345C6.33167 10.077 6.1835 9.94412 6.01392 9.8438C5.84433 9.74347 5.65664 9.67749 5.46156 9.6497C5.26649 9.62192 5.06786 9.63295 4.877 9.68193C4.68614 9.73091 4.5068 9.81688 4.34921 9.93516C4.19163 10.0535 4.05888 10.2017 3.95856 10.3713C3.85823 10.5409 3.7923 10.7285 3.76451 10.9236C3.73672 11.1186 3.74763 11.3174 3.7966 11.5082C3.84558 11.6991 3.93167 11.8783 4.04996 12.0359L8.07296 17.4C8.19362 17.5609 8.34542 17.6959 8.51932 17.797C8.69322 17.8981 8.88568 17.9631 9.08524 17.9883C9.28479 18.0135 9.48738 17.9983 9.68094 17.9436C9.87451 17.889 10.0551 17.7958 10.212 17.6699L20.583 9.34502C20.8313 9.1511 21.0124 8.88388 21.1003 8.58128C21.1882 8.27869 21.1787 7.956 21.0729 7.65916C20.9672 7.36233 20.7706 7.1063 20.5111 6.92747C20.2517 6.74865 19.9425 6.65607 19.6275 6.66289Z'
												fill='#11BC59'
											/>
										</svg>
										<p className={'question-select-option'}>{'Yes'}</p>
									</div>
									<div
										className={`question-button ${
											noSelectedIndex0 ? 'question-button-selected' : ''
										}`}
										onClick={onQuestionSelectHandler.bind(null, false)}>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='25'
											height='24'
											viewBox='0 0 25 24'
											fill='none'>
											<path
												fill-rule='evenodd'
												clip-rule='evenodd'
												d='M8.25587 5.40891C7.95773 5.40924 7.66644 5.49844 7.4192 5.66508C7.17196 5.83171 6.97999 6.06816 6.86779 6.3444C6.75559 6.62063 6.72825 6.92396 6.78927 7.2158C6.85029 7.50763 6.9969 7.77469 7.21037 7.98282L11.2244 11.9969L7.21037 16.0109C7.06711 16.1493 6.95284 16.3148 6.87422 16.4978C6.79561 16.6808 6.75423 16.8776 6.7525 17.0768C6.75077 17.2759 6.78872 17.4734 6.86414 17.6578C6.93956 17.8421 7.05094 18.0096 7.19178 18.1505C7.33262 18.2913 7.5001 18.4026 7.68444 18.4781C7.86879 18.5535 8.06631 18.5915 8.26548 18.5898C8.46464 18.588 8.66147 18.5466 8.84448 18.468C9.02749 18.3894 9.193 18.2751 9.33137 18.1318L13.3454 14.118L17.3624 18.1318C17.5007 18.2751 17.6663 18.3894 17.8493 18.468C18.0323 18.5466 18.2291 18.588 18.4283 18.5898C18.6274 18.5915 18.825 18.5535 19.0093 18.4781C19.1936 18.4026 19.3611 18.2913 19.502 18.1505C19.6428 18.0096 19.7542 17.8421 19.8296 17.6578C19.905 17.4734 19.943 17.2759 19.9412 17.0768C19.9395 16.8776 19.8981 16.6808 19.8195 16.4978C19.7409 16.3148 19.6266 16.1493 19.4834 16.0109L15.4694 11.9969L19.4834 7.98282C19.6998 7.77205 19.8476 7.50097 19.9073 7.20481C19.967 6.90865 19.9359 6.60134 19.818 6.32316C19.7002 6.04497 19.5011 5.80879 19.2468 5.64567C18.9925 5.48254 18.6949 5.40005 18.3929 5.40891C18.0036 5.42041 17.634 5.58286 17.3624 5.86191L13.3454 9.87595L9.33137 5.86191C9.19147 5.71838 9.02421 5.60427 8.83948 5.52646C8.65476 5.44866 8.45632 5.40873 8.25587 5.40891Z'
												fill='#EB5757'
											/>
										</svg>
										<p className={'question-select-option'}>{'No'}</p>
									</div>
								</div>
							</>
						)}
					</>
				)}

				{state === STATES.PHYSICAL_ACTIVITY && (
					<>
						<p className={'customer-experience-body-title'}>
							What level of physical movements suit you?
						</p>
						<div
							className={'customer-experience-body-container'}
							style={{ marginTop: '92px', width: '100%' }}>
							{OptionsOnPhysicalIntensity?.map((option: any, index: number) => (
								<IconWithTitlePhysical
									selectOptionHandler={selectOptionHandlerPhysicalActivity}
									selectedIndex={selectedIndexThree}
									index={index}
									title={option.title}
									icon={option.icon}
									key={index}
								/>
							))}
						</div>
					</>
				)}

				{state === STATES.VIDEO_TESTIMONIAL_PHYSICAL && (
					<>
						{!isVideoPlayingTwo && (
							<div
								style={{
									position: 'absolute',
									zIndex: 0,
									top: '50%',
									left: '50%',
									transform: 'translate(-50%, -50%)',
								}}>
								<Loader grey />
							</div>
						)}
						{
							<ReactPlayer
								controls={false}
								playing={true}
								autoPlay={true}
								muted={muted}
								loop={true}
								playsinline={true}
								fileconfig={{ attributes: { autoPlay: true } }}
								url={videoUrlTwo}
								width={'100%'}
								onPlay={() => {
									setIsVideoPlayingTwo(true);
									setTimeout(
										() => {
											setIsVideoEndedTwo(true);
										},
										isOnboardingA ? 0 : 5000
									);
								}}
								height={472}
								style={{
									display: 'flex',
									width: '100%',
									maxWidth: '327px',
									maxHeight: '472px',
									height: 'auto',
									alignSelf: 'center',
									opacity: isVideoPlayingTwo ? '1' : '0.01',
									margin: '0 auto',
								}}
							/>
						}
						<Button
							disabled={!isVideoEndedTwo}
							isSticky={true}
							style={{
								alignSelf: 'center',
								marginBottom: '24px',
								background: !isVideoEndedTwo
									? 'var(--Inactive-Color, #D6D6D6)'
									: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
							}}
							onClick={selectOptionHandlerVideoPhysical}
							label={'Okay'}></Button>
					</>
				)}
				{state === STATES.TEXT_TESTIMONIAL_365_DAYS && (
					<>
						<div style={{ marginTop: '232px' }}>
							<TextAnimation
								style={{
									color: '#1B1625',
									textAlign: 'center',
									fontFamily: 'Galaxie-Copernicus-Book',
									fontSize: '24px',
									fontStyle: 'normal',
									width: '343px',
									fontWeight: 400,
									lineHeight: '32px',
								}}
								startAnimation={true}
								index={1}
								title={'We practice with you 365 days a year'}
								onAnimationComplete={onAnimation365Complete}
							/>
						</div>
						<Button
							disabled={!animation365Complete}
							isSticky={true}
							style={{
								alignSelf: 'center',
								marginBottom: '24px',
								background: !animation365Complete
									? 'var(--Inactive-Color, #D6D6D6)'
									: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
							}}
							onClick={selectOptionHandler365Testimonial}
							label={'Okay'}></Button>
					</>
				)}

				{state === STATES.ATTENDANCE_ANIMATION && (
					<>
						<p className={'customer-experience-body-title'}>
							Seek users are the most regular
						</p>
						<svg
							style={{ marginTop: '-37px', width: '100px' }}
							xmlns='http://www.w3.org/2000/svg'
							width='154'
							height='26'
							viewBox='0 0 154 26'
							fill='none'>
							<mask
								id='mask0_394_873'
								maskUnits='userSpaceOnUse'
								x='0'
								y='0'
								width='154'
								height='26'>
								<path d='M154 0.233398H0V25.7562H154V0.233398Z' fill='white' />
							</mask>
							<g mask='url(#mask0_394_873)'>
								<path
									d='M2.07084 15.9166C-0.0250341 14.7163 0.293469 13.6372 3.02636 12.6792C5.75925 11.7212 10.2915 11.1057 16.623 10.8329C18.0241 10.8128 19.3797 10.8048 20.6898 10.8089C22.0909 10.7888 23.143 10.7149 23.8463 10.5872C24.5923 10.5651 26.5362 10.5183 29.6778 10.4468C32.9773 10.392 36.8983 10.3188 41.4411 10.2272C46.0508 10.1765 50.8301 10.11 55.7793 10.0278C60.7953 9.98645 65.4838 9.94406 69.8447 9.90066C74.2964 9.83318 78.0022 9.78776 80.9626 9.7644C83.9223 9.74105 85.5596 9.7461 85.8759 9.77956C86.0518 9.96689 86.5464 10.0699 87.3596 10.0887C88.3295 10.1242 89.1666 10.078 89.8695 9.95024C90.7313 9.8392 91.7374 9.77733 92.8902 9.76464C94.1092 9.79277 94.9433 9.86437 95.3923 9.97946C95.9802 9.94066 96.6476 9.91024 97.3937 9.88818C98.207 9.90692 98.8281 9.88854 99.2586 9.83302C99.6891 9.77749 100.141 9.77483 100.614 9.82501C101.178 9.85112 101.677 9.83641 102.106 9.78089C103.459 9.89064 105.434 9.982 108.03 10.055C110.717 10.1039 113.732 10.1538 117.074 10.2047C120.483 10.2964 123.904 10.3557 127.338 10.3825C130.838 10.4502 134.101 10.4927 137.127 10.5102C140.154 10.5276 142.696 10.5274 144.752 10.5093C146.807 10.4913 148.051 10.4545 148.481 10.399C150.046 10.1602 151.259 10.4238 152.123 11.1899C152.821 11.2976 153.446 11.6 154 12.0971C154 12.0971 153.839 12.1982 153.518 12.4002C153.355 12.619 153.052 12.9917 152.611 13.5182C152.261 14.0206 151.644 14.3598 150.759 14.5357C149.941 14.7525 148.931 14.9321 147.73 15.0746C146.415 15.306 145.135 15.4401 143.892 15.4769C142.739 15.4896 140.956 15.4354 138.542 15.3143C136.219 15.169 132.563 14.9669 127.577 14.7079C126.357 14.6798 125.105 14.6312 123.819 14.5623C122.69 14.5101 121.608 14.4458 120.571 14.3695C119.69 14.3099 118.923 14.2792 118.268 14.2771C117.703 14.251 117.331 14.2621 117.149 14.3103C116.718 14.3657 115.939 14.3674 114.811 14.3152C113.84 14.2798 112.654 14.272 111.254 14.2921C110.216 14.2158 108.727 14.1422 106.786 14.0712C104.845 14.0002 102.825 13.9209 100.726 13.8332C98.6938 13.7864 96.8644 13.7442 95.2395 13.7067C93.7041 13.6451 92.8454 13.6384 92.6641 13.6865C92.3246 13.718 91.9064 13.7411 91.4088 13.7558C90.9782 13.8113 90.459 13.7731 89.8533 13.6413C89.6758 13.454 89.2484 13.3918 88.5694 13.4546C88.0486 13.5342 87.7878 13.574 87.7878 13.574C87.0602 13.7667 83.964 13.8262 78.4983 13.7525C75.9453 13.7852 72.1149 13.8343 67.0079 13.8998C61.9679 14.0061 56.3516 14.1187 50.1591 14.2376C44.1244 14.3733 38.1685 14.5174 32.2914 14.6698C26.5055 14.7982 21.4988 14.9248 17.2715 15.0499C13.111 15.2157 10.464 15.3903 9.33019 15.5736C6.97184 15.9642 5.3742 16.1826 4.5373 16.2288C3.60948 16.299 2.78732 16.195 2.07084 15.9166Z'
									fill='#FAA53D'
								/>
							</g>
						</svg>
						<div
							className={'customer-experience-body-container'}
							style={{ width: '100%' }}>
							<div className={'customer-experience-animation-container'}>
								<p className={'customer-experience-body-animation-title'}>
									Attendance
								</p>
								<div className={'customer-experience-body-animation'}>
									<BezierCurve />
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											width: '100%',
										}}>
										<p className={'customer-experience-body-week'}>Week 1</p>
										<p className={'customer-experience-body-week'}>Week 12</p>
									</div>
								</div>
							</div>
							<p className={'customer-experience-body-animation-subtitle'}>
								Based on data of Seek, 2500+ users joined in last 4 months.
							</p>
						</div>
						<Button
							disabled={!isAttendanceAnimationDone}
							isSticky={true}
							style={{
								alignSelf: 'center',
								marginBottom: '24px',
								background: !isAttendanceAnimationDone
									? 'var(--Inactive-Color, #D6D6D6)'
									: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
							}}
							onClick={onAttendanceAnimationComplete}
							label={'Great'}></Button>
					</>
				)}

				{state === STATES.VIDEO_TESTIMONIAL_TIME && (
					<>
						{!isVideoPlayingThree && (
							<div
								style={{
									position: 'absolute',
									zIndex: 0,
									top: '50%',
									left: '50%',
									transform: 'translate(-50%, -50%)',
								}}>
								<Loader grey />
							</div>
						)}
						<ReactPlayer
							controls={false}
							playing={true}
							autoPlay={true}
							muted={muted}
							loop={true}
							playsinline={true}
							fileconfig={{ attributes: { autoPlay: true } }}
							url={video4}
							width={'100%'}
							onPlay={() => {
								setIsVideoPlayingThree(true);
								setTimeout(
									() => {
										setIsVideoEndedThree(true);
									},
									isOnboardingA ? 0 : 5000
								);
							}}
							height={472}
							style={{
								display: 'flex',
								width: '100%',
								maxWidth: '327px',
								maxHeight: '472px',
								height: 'auto',
								alignSelf: 'center',
								margin: '0 auto',
								opacity: isVideoPlayingThree ? '1' : '0.01',
							}}
						/>
						<Button
							disabled={!isVideoEndedThree}
							isSticky={true}
							style={{
								alignSelf: 'center',
								marginBottom: '24px',
								background: !isVideoEndedThree
									? 'var(--Inactive-Color, #D6D6D6)'
									: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
							}}
							onClick={selectOptionHandlerVideoTime}
							label={'Okay'}></Button>
					</>
				)}
				{state === STATES.TEXT_TESTIMONIAL_7_SLOTS && (
					<>
						<div style={{ marginTop: '232px' }}>
							<TextAnimation
								style={{
									color: '#1B1625',
									textAlign: 'center',
									fontFamily: 'Galaxie-Copernicus-Book',
									fontSize: '24px',
									fontStyle: 'normal',
									width: '343px',
									fontWeight: 400,
									lineHeight: '32px',
								}}
								startAnimation={true}
								index={1}
								title={'7 time slots everyday'}
								onAnimationComplete={on7SlotsFirstAnimationComplete}
							/>
							<TextAnimation
								style={{
									color: '#1B1625',
									fontFamily: 'Gordita-Medium',
									fontSize: '20px',
									fontStyle: 'normal',
									fontWeight: 500,
									lineHeight: '28px',
								}}
								startAnimation={startAnimationTwo}
								index={2}
								title={' Attend as many as you want.'}
								onAnimationComplete={on7SlotsFirstAnimationComplete}
							/>
						</div>
						<Button
							disabled={!is7SlotsAnimationEnded}
							isSticky={true}
							style={{
								alignSelf: 'center',
								marginBottom: '24px',
								background: !is7SlotsAnimationEnded
									? 'var(--Inactive-Color, #D6D6D6)'
									: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
							}}
							onClick={selectOptionHandler7slotsTestimonial}
							label={'Okay'}></Button>
					</>
				)}
			</div>
		</Container>
	);
};

export default CustomerExperiencePage;
